<h2 mat-dialog-title>Eliminar</h2>
<mat-dialog-content>
    <p>¿Desea eliminar el registro seleccionado?</p>
</mat-dialog-content>

<div mat-dialog-actions>
    <button mat-raised-button (click)="onNoClick()" cdkFocusInitial>Cancelar</button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
</div>